import IconCloseModal from "app/components/Icon/components/IconCloseModal/IconCloseModal";
import IconLogoModal from "app/components/Icon/components/IconLogoModal/IconLogoModal";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

type ModalHeaderProps = {
  isRegistrationModalOpen: boolean;
  setRegistrationModalClosed: () => void;
};

const ModalHeader = ({
  isRegistrationModalOpen,
  setRegistrationModalClosed,
}: ModalHeaderProps): JSX.Element => {
  if (!isRegistrationModalOpen) return null;

  return (
    <div className="registration-form-modal__header">
      <div className={"registration-form-modal__header--logo"}>
        <IconLogoModal />
      </div>
      <div className={"registration-form-modal__header--registration"}>
        <FormattedMessage tagName="div" id="registrations-registration-text" />
      </div>
      <div
        className={"registration-form-modal__header--close"}
        onClick={() => setRegistrationModalClosed()}
      >
        <IconCloseModal />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isRegistrationModalOpen: state.registrationFormModel.isRegistrationModalOpen,
});

const mapDispatchToProps = dispatch => ({
  setRegistrationModalClosed: () => {
    dispatch.registrationFormModel.setRegistrationModalClosed();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ModalHeader));
